import React, { useEffect, useMemo, useState } from "react";
import payApi from "../utils/payApi";

export default function Payment({
  pricePerMember,
  teamMembersCount,
  transactions: providedTransactions,
}) {
  const [amount, setAmount] = useState("");
  const [error, setError] = useState("");
  const [transactions, setTransactions] = useState(
    Array.isArray(providedTransactions) ? providedTransactions : []
  );

  useEffect(() => {
    if (Array.isArray(providedTransactions)) {
      setTransactions(providedTransactions);
      return;
    }

    let mounted = true;
    payApi
      .getPaymentStatus()
      .then((res) => {
        if (mounted) setTransactions(res.data.transactions || []);
      })
      .catch((err) => {
        console.error("Error fetching payment status:", err);
        if (mounted) setError("خطا در بررسی وضعیت پرداخت.");
      });

    return () => {
      mounted = false;
    };
  }, [providedTransactions]);

  useEffect(() => {
    if (pricePerMember && teamMembersCount >= 0) {
      const safePrice = Number(pricePerMember || 0);
      const safeCount = Number(teamMembersCount || 0);
      const total = safePrice * (1 + safeCount);
      setAmount(String(total));
    }
  }, [pricePerMember, teamMembersCount]);

  const totalAmount = useMemo(() => {
    const successful = transactions.filter((tx) => tx.status);
    return successful.reduce((sum, tx) => sum + tx.amount, 0);
  }, [transactions]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!amount) {
      setError("مبلغ پرداخت قابل محاسبه نیست.");
      return;
    }

    try {
      const callbackUrl = `${process.env.REACT_APP_BACKEND_URL}/api/pay/callback/`;
      const finalamount = amount - totalAmount;
      const { data } = await payApi.createTransaction(finalamount, callbackUrl);
      window.location.href = `https://panel.aqayepardakht.ir/startpay/${data.transid}`;
    } catch (err) {
      console.error(err.response?.data || err);
      setError("خطا در ایجاد تراکنش. لطفا دوباره تلاش کنید.");
    }
  };

  return (
    <form onSubmit={handleSubmit} dir="rtl" className="w-full max-w-sm mx-auto">
      <h1>شما تایید اولیه شدید ،برای شرکت در لیگ صورت حساب زیر را پرداخت کنید.</h1>
      <p className="mb-4 font-semibold">مبلغ نهایی پرداخت:</p>
      مبلغ پرداختی شما تاکنون : {totalAmount.toLocaleString()} تومان
      <br></br>
      مبلغ باقی مانده قابل پرداخت شما: {(amount - totalAmount).toLocaleString()} تومان
      <div className="rounded-lg border border-gray-700 bg-black px-4 py-3 text-white">
        {teamMembersCount + 1} عضو × {Number(pricePerMember || 0).toLocaleString()} تومان
        <br />
        <span className="text-lime-400 font-bold mt-2 inline-block">
          = {Number(amount || 0).toLocaleString()} تومان
        </span>
      </div>

      {error && <p className="text-red-500 mt-3">{error}</p>}

      <button
        type="submit"
        className="mt-5 w-full rounded-lg bg-lime-600 py-2 text-white hover:bg-lime-700"
      >
        پرداخت
      </button>
    </form>
  );
}
